// import Link from "@mui/material/Link";

import PropTypes from "prop-types";
import { Box, ButtonBase } from "@mui/material";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export const SideNavItem = (props) => {
  const {
    active = false,
    disabled,
    external,
    icon,
    path,
    title,
    isRow,
  } = props;
  const { color } = useSelector((state) => state.color);

  const linkProps = path
    ? external
      ? {
          component: "a",
          href: path,
          target: "_blank",
        }
      : {
          component: Link,
          to: path,
          href: path,
        }
    : {};

  return (
    <Box component={isRow ? "div" : "li"} style={isRow ? { marginTop: 0 } : {}}>
      <ButtonBase
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "flex-start",
          pl: "16px",
          pr: "16px",
          ...(!isRow && { py: "6px", borderRadius: 1 }),
          textAlign: "left",
          textDecoration: "none !important",

          ...(active &&
            (isRow
              ? {
                  borderBottom: "1px solid #1186c0",
                }
              : {
                  backgroundColor: "rgba(255, 255, 255, 0.04)",
                })),
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.04)",
            textDecoration: "none !important",
          },
        }}
        {...linkProps}
      >
        {icon && (
          <Box
            component="span"
            sx={{
              alignItems: "center",
              display: "inline-flex",
              justifyContent: "center",
              mr: 2,
              ...(isRow
                ? {
                    color: "#545454",
                  }
                : {
                    color: "neutral.400",
                  }),
              ...(active &&
                (isRow
                  ? {
                      color: "#1186c0",
                    }
                  : {
                      color: color,
                    })),
            }}
          >
            {icon}
          </Box>
        )}
        <Box
          component="span"
          sx={{
            ...(isRow
              ? {
                  color: "#545454",
                }
              : {
                  color: "neutral.400",
                }),
            flexGrow: 1,
            fontFamily: (theme) => theme.typography.fontFamily,
            fontSize: 14,
            fontWeight: 600,
            lineHeight: "24px",
            whiteSpace: "nowrap",
            ...(active &&
              (isRow
                ? {
                    color: "#1186c0",
                    textDecoration: "none !important",
                  }
                : {
                    color: "common.white",
                  })),
            ...(disabled && {
              color: "neutral.500",
            }),
          }}
        >
          {title}
        </Box>
      </ButtonBase>
    </Box>
  );
};

SideNavItem.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  external: PropTypes.bool,
  icon: PropTypes.node,
  path: PropTypes.string,
  title: PropTypes.string.isRequired,
};
